import { FullBaseUrl } from "../api/ApiUrl";

export const IDENTITY_CONFIG = {  
  authority: "https://auth.pingone.com/6b6ac0d9-059d-4001-86af-8580aa7e47cb/as",   
  client_id: "9b8c8336-feaf-46c3-bfb5-2e7936c2f11a",    
  redirect_uri: `${window.location.origin}/clinicportal/ng/`,
  response_type: "token id_token",   
  scope: "openid",   
  // scope: "openid profile wf-2-api.full",   
  post_logout_redirect_uri: `${FullBaseUrl()}/sso`, }
